module.exports = __webpack_public_path__ + "05_glasses_black.f382d2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/05_glasses_black.png
// module id = K8C8
// module chunks = 0